import { formatNumberMix } from '@/utils'
import moment from 'moment'
import { TREND_LIST } from '@/config'
const filterData = ['showNum', 'clickNum', 'landingPageViewNum', 'addPurchaseNum', 'paymentNum', 'orderNum']

const keyToRate = {
  clickNum: 'clickRate',
  landingPageViewNum: 'viewRate',
  addPurchaseNum: 'addPurchaseRate',
  paymentNum: 'paymentRate',
  orderNum: 'transRate'
}
export default {
  data() {
    return {
      loadingSale: {
        overviewData: true,
        adCostTop: true,
        payamountTop: true,
        roiTop: true,
        campaignTop: true,
        adTransData: true,
        trendData: true,
        salesEcharts: true
      },
      adCostTop: {},// 广告花费top5
      payamountTop: {}, // 广告成交额top5
      roiTop: {}, // 广告ROItop5
      campaignTop: {}, // 广告系列top5
      salesEcharts: {}, // 广告营销趋势
      adTransData: {}, // 广告转化漏斗
      trendData: {} // 趋势分析
    }
  },
  methods: {
    setAdCostTop(data, param) {
      return {
        title: this.$t('ad-analysis::广告花费Top5'),
        type: 'ring',
        ref: 'adCostTopEchart',
        height: '325px',
        tip: '',
        chart: {
          tooltip: {
            trigger: 'item',
            formatter: (params, ticket, callback) => {
              return `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color}"></span><span>${params.name}  </span><span style="font-weight:900;">${params.value}</span><br/>
                            <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;"></span><span>${params.name}  </span><span style="font-weight:900;">${params.data.rate}%</span>`
            }
          },
          legend: {
            type: 'scroll',
          },
          series: [
            {
              type: 'pie',
              radius: ['50%', '70%'],
              label: {
                show: false,
                position: 'left'
              },
              itemStyle: {
                normal: {
                  labelLine: {
                    show: false
                  }
                }
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: '12'
                }
              },
              labelLine: {
                show: false
              },
              data: data.map(item => {
                return {
                  value: item.adSpend,
                  rate: item.adSpendRate,
                  name: item.demension
                }
              })
            }
          ]
        }
      }
    },
    setPayamountTop(data, param) {
      return {
        title: this.$t('ad-analysis::广告成交额Top5'),
        type: 'ring',
        ref: 'payamountTopEchart',
        height: '325px',

        chart: {
          tooltip: {
            trigger: 'item',
            formatter: (params, ticket, callback) => {
              return `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color}"></span><span>${params.name}  </span><span style="font-weight:900;">${params.value}</span><br/>
                            <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;"></span><span>${params.name}  </span><span style="font-weight:900;">${params.data.rate}%</span>`
            }
          },
          legend: {
            type: 'scroll',
          },
          series: [
            {
              type: 'pie',
              radius: ['50%', '70%'],
              label: {
                show: false,
                position: 'left'
              },
              itemStyle: {
                normal: {
                  labelLine: {
                    show: false
                  }
                }
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: '12'
                }
              },
              labelLine: {
                show: false
              },
              data: data.map(item => {
                return {
                  value: item.payAmount,
                  rate: item.payAmountRate,
                  name: item.demension
                }
              })
            }
          ]
        }
      }
    },
    setRoiTop(data, param) {
      return {
        title: this.$t('board::广告ROI Top5'),
        type: 'ring',
        ref: 'roiTopEchart',
        height: '325px',
        tip: '',
        chart: {
          tooltip: {
            trigger: 'item',
            formatter: (params, ticket, callback) => {
              return `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color}"></span><span>${params.name}  </span><span style="font-weight:900;">${params.value}</span><br/>
                            <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;"></span><span>${params.name}  </span><span style="font-weight:900;">${params.data.rate}%</span>`
            }
          },
          legend: {
            type: 'scroll',
          },
          series: [
            {
              type: 'pie',
              radius: ['50%', '70%'],
              label: {
                show: false,
                position: 'left'
              },
              itemStyle: {
                normal: {
                  labelLine: {
                    show: false
                  }
                }
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: '12'
                }
              },
              labelLine: {
                show: false
              },
              data: data.map(item => {
                return {
                  value: item.roi,
                  rate: item.roiRate,
                  name: item.demension
                }
              })
            }
          ]
        }
      }
    },
    setCampaignTop(data, param) {
      return {
        type: 'table',
        title: this.$t('ad-analysis::广告系列不同维度Top5'),
        cancelShadow: true,
        ref: 'campaignTable',
        height: '305px',
        tableData: data,
        filterParam: true,
        filter: param.demension || 'ad_spend',
        filterOptions: [{ label: window.$t('ad-analysis::cost_title'), value: 'ad_spend' }, { label: window.$t('ad-analysis::广告成交额'), value: 'pay_amount' }, { label: window.$t('ad-analysis::广告ROI'), value: 'roi' }]
      }
    },
    // 构建广告转化漏斗
    setTransData(data, param) {
      let that = this
      data = data[0] || {}
      let datas = filterData
        .filter(item => data.hasOwnProperty(item))
        .map((key, index) => ({
          name: `${that.transToWord(key)}`,
          // value: 100 - index * 20,
          value: data[key],
          key
        }))
      const str = `${moment(param.startDate).format('YYYY年MM月DD日')}${window.$t('system::time::text::include')}${moment(param.endDate).format('MM月DD日')}`
      return {
        type: 'funnel',
        // tip: str,
        title: this.$t('board::adfunnel_title'),
        ref: 'funnelChartVistor',
        height: '305px',
        chart: {
          legend: {
            type: 'scroll',
            left: 'center',
            bottom: '4%',
            orient: 'horizontal',
            textStyle: {}
          },
          tooltip: {
            trigger: 'item',
            formatter: (params, ticket, callback) => {
              if (params.data.key === 'showNum') return ''
              return `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color
                }"></span><span>${that.transToRate(keyToRate[params.data.key])}  </span><span style="font-weight:900;">${data[keyToRate[params.data.key]]
                }%</span>`
            }
          },
          series: [
            {
              type: 'funnel',
              left: '10%',
              top: 60,
              bottom: 60,
              width: '80%',
              min: 0,
              // max: 100,
              sort: 'none',

              label: {
                show: true,
                position: 'inside',
                formatter: item => item.data.name + ' ' + data[item.data.key]
              },

              itemStyle: {
                normal: {
                  labelLine: {
                    show: false
                  }
                }
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '12'
                }
              },
              labelLine: {
                show: false
              },
              data: datas
            }
          ]
        }
      }
    },
    // 趋势分析
    setTrendData(data, param) {
      const arrayMeasure1 = data.map(item => Number(item.measureValue1))
      const arrayMeasure2 = data.map(item => Number(item.measureValue2))
      const arrayDate = data.map(item => item.date)
      const TitleMeasure1 =
        (TREND_LIST.find(item => item.value === param.measure1) &&
          TREND_LIST.find(item => item.value === param.measure1).label) ||
        ''
      const TitleMeasure2 =
        (TREND_LIST.find(item => item.value === param.measure2) &&
          TREND_LIST.find(item => item.value === param.measure2).label) ||
        ''
      let backLengeds = [TitleMeasure1, TitleMeasure2]
      const str = `${moment(param.startDate).format('YYYY年MM月DD日')}${window.$t('system::time::text::include')}${moment(param.endDate).format('MM月DD日')}`
      return {
        type: 'line',
        title: this.$t('board::trend_title'),
        // tip: str,
        ref: 'salesLine',
        height: '260px',
        chart: {
          legend: {
            data: backLengeds
          },
          tooltip: {
            formatter: (params, ticket, callback) => {
              let str = ''
              params.forEach(item => {
                if (item.seriesName === backLengeds[0]) {
                  str = `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${item.color}"></span>`
                  str += `<span>${backLengeds[0]} </span><span style="font-weight:900;">${item.value}${backLengeds[0].indexOf('率') > -1 ? '%' : ''
                    }</span> <br/> `
                }
                if (item.seriesName === backLengeds[1]) {
                  str += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${item.color}"></span>`
                  str += `<span>${backLengeds[1]} </span><span style="font-weight:900;">${item.value}${backLengeds[1].indexOf('率') > -1 ? '%' : ''
                    }</span>`
                }
              })
              return str
            }
          },
          xAxis: {
            data: arrayDate
          },
          yAxis: [
            {
              type: 'value',
              min: 0,
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              },
              axisLabel: {
                margin: 16,
                color: '#999999',
                formatter: value => {
                  return backLengeds[0].indexOf('率') > -1 ? `${value}%` : value
                }
              }
            },
            {
              type: 'value',
              min: 0,
              splitLine: {
                show: false
              },
              axisLabel: {
                margin: 16,
                color: '#999999',
                formatter: value => {
                  return backLengeds[1].indexOf('率') > -1 ? `${value}%` : value
                }
              }
            }
          ],
          series: [
            {
              name: TitleMeasure1,
              type: 'line',
              areaStyle: {
                opacity: 0
              },
              stack: 1,
              data: arrayMeasure1
            },
            {
              name: TitleMeasure2,
              type: 'line',
              areaStyle: {
                opacity: 0
              },
              yAxisIndex: 1,
              stack: 2,
              data: arrayMeasure2
            }
          ]
        }
      }
    },
    // 广告营销趋势
    setSalesEcharts(data) {
      return {
        title: this.$t('ad-analysis::echarts_广告营销趋势'),
        type: 'line',
        ref: 'lineChart',
        height: '325px',
        chart: {
          legend: {
            show: true,
            data: [this.$t('ad-analysis::echarts_FB成交额'), this.$t('ad-analysis::echarts_谷歌成交额'), 'FB-ROI', this.$t('ad-analysis::echarts_谷歌-ROI')]
          },
          tooltip: {
            formatter: (params, ticket, callback) => {
              let str = `${params[0].name}<br/>`
              params.forEach(item => {
                str += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${item.color}"></span>`
                str += `<span>${item.seriesName} </span><span style="font-weight:900;">${item.value}</span> <br/> `
              })
              return str
            }
          },
          xAxis: {
            data: data.map(item => item.date)
          },
          yAxis: [
            {
              type: 'value',
              name: '成交额',
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              },
              min: 0,

            },
            {
              type: 'value',
              min: 0,
              name: 'ROI',
              axisLabel: {
                formatter: '{value}'
              }
            }
          ],
          series: [
            {
              name: this.$t('ad-analysis::echarts_FB成交额'),
              type: 'bar',
              data: data.map(item => Number(item.fbPayAmount))
            },
            {
              name: this.$t('ad-analysis::echarts_谷歌成交额'),
              type: 'bar',
              data: data.map(item => Number(item.googlePayAmount))
            },
            {
              name: 'FB-ROI',
              type: 'line',
              yAxisIndex: 1,
              data: data.map(item => Number(item.fbRoi))
            },
            {
              name: this.$t('ad-analysis::echarts_谷歌-ROI'),
              type: 'line',
              yAxisIndex: 1,
              data: data.map(item => Number(item.googleRoi))
            }
          ]
        }
      }
    },
    transToWord(key) {
      switch (key) {
        case 'showNum':
          return this.$t('board::adfunnel::funnel_show')
        case 'clickNum':
          return this.$t('board::adfunnel::funnel_click')
        case 'landingPageViewNum':
          return this.$t('board::adfunnel::funnel_visitor')
        case 'addPurchaseNum':
          return this.$t('board::adfunnel::funnel_addBuy')
        case 'paymentNum':
          return this.$t('ad-analysis::下单量')
        case 'orderNum':
          return this.$t('ad-analysis::成交量')
      }
    },
    transToRate(key) {
      switch (key) {
        case 'clickRate':
          return this.$t('board::trend::line_clickRate')
        case 'viewRate':
          return this.$t('board::trend::line_visitorRate')
        case 'addPurchaseRate':
          return this.$t('board::trend::line_addBuyRate')
        case 'paymentRate':
          return this.$t('board::trend::line_paymentRate')
        case 'transRate':
          return this.$t('board::trend::line_transRate')
      }
    }
  }
}
